// extracted by mini-css-extract-plugin
export default {"label":"RsvpQuestionTextAnswersSummary_label__zAa6B","switchWrapper":"RsvpQuestionTextAnswersSummary_switchWrapper__Zm0cW"};